import { Layout } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const StyledHeader = styled(Layout.Header)`
  && {
    overflow-y: hidden;
    padding-bottom: 1px;
    scrollbar-gutter: auto;
  }
`

export const HeaderSubtitleBlock = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Content = styled(Layout.Content)`
  & > div {
    gap: ${({ theme }) => theme.size.space['03']};
  }
`
